import { GoogleSheetsServiceComponent } from './GoogleSheetsServiceComponent';
export const GoogleSheetsReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: GoogleSheetsServiceComponent
};